import React from "react";

import { Button } from "~/components/ui/button";

interface CoachCardLockProps {
  onClick?: () => void;
}

export const CoachCardLock = ({ onClick }: CoachCardLockProps) => (
  <div className="absolute inset-0 z-20 rounded-2xl bg-white/80 backdrop-blur-sm">
    <div className="flex h-full w-full flex-col items-center justify-center gap-3 p-8">
      <Button
        size="lg"
        variant="primary"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (onClick) {
            onClick();
          }
        }}
        className="shadow-sm"
      >
        Sign up to reveal
      </Button>
      <p className="text-center text-sm text-gray-500">
        Free account — see all your matches
      </p>
    </div>
  </div>
);
